import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-160fa04a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container tw-flex tw-items-center" }
const _hoisted_2 = { class: "information-container tw-flex" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  "data-cy": "card-role-setting-role-name",
  class: "information tw-flex tw-flex-none tw-flex-col tw-mr-12 tw-leading-[normal]"
}
const _hoisted_5 = { class: "name tw-font-[500]" }
const _hoisted_6 = { class: "email tw-text-[12px] grey-color" }
const _hoisted_7 = { class: "company tw-text-[13px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data['imgSrc'])
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "image-info",
            src: _ctx.data['imgSrc']
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(`${_ctx.data.firstName} ${_ctx.data.lastName}`), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.data.email), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.data.homeOrgNameShort), 1)
  ]))
}